var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{staticClass:"p-2",attrs:{"variant":'status_'+_vm.status}},[_vm._v(_vm._s(_vm.$t(_vm.history_event_translator[_vm.status])))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }